// @ts-ignore
import { getGlobalModalConfig } from 'hzero-front/lib/models/global';
import { getWrapperRouterData } from "../utils-router";
export default (function (app) {
  return getGlobalModalConfig({
    getWrapperRouterData: getWrapperRouterData,
    app: app
  });
});